import React, { FC } from 'react';
import styled from 'styled-components';

import { Match } from '../../../../database.schema';
import { MatchPlayer } from './match-player';
import { SetMatchResult } from './set-match-result';

const DropWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const MatchWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

type Props = {
  recordedMatch: Match[];
  onChangePlayerScore: (points: number, playerIndex: number, matchIndex: number, team: string) => void;
  onMatchResultChange: (result: string, matchIndex: number) => void;
  onMatchMarginChange: (margin: string, matchIndex: number) => void;
};

export const ResultEntryPairs: FC<Props> = ({ recordedMatch, onChangePlayerScore, onMatchMarginChange, onMatchResultChange }): JSX.Element | null => {
  const matchHasSingles = recordedMatch[0].team1.players.length % 2 !== 0;
  const pairIndex = matchHasSingles ? 0 : 1;

  return (
    <div>
      {recordedMatch.map(
        (match: Match, index: number): JSX.Element => (
          <div key={`result-${index}`}>
            {matchHasSingles && match.team1.players.length === 1 ? (
              <div>
                <h3>Singles Entry</h3>
                <DropWrapper data-testid={`singles-${index}`}>
                  <MatchPlayer
                    match={match}
                    player={recordedMatch[index].team1.players?.[0]}
                    team="team1"
                    bgColor="red"
                    playerIndex={0}
                    matchIndex={index}
                    onChangePlayerScore={onChangePlayerScore}
                  />
                  <SetMatchResult match={match} matchIndex={index} onMatchResultChange={onMatchResultChange} onMatchMarginChange={onMatchMarginChange} />
                  <MatchPlayer
                    match={match}
                    player={recordedMatch[index].team2.players?.[0]}
                    team="team2"
                    bgColor="blue"
                    playerIndex={0}
                    matchIndex={index}
                    onChangePlayerScore={onChangePlayerScore}
                  />
                </DropWrapper>
              </div>
            ) : (
              <div>
                <h3>Pair Entry {pairIndex + index}</h3>
                <DropWrapper data-testid="FRED1">
                  <MatchWrapper data-testid="FRED1-1">
                    <MatchPlayer
                      playerIndex={0}
                      match={match}
                      player={match.team1.players?.[0]}
                      team="team1"
                      bgColor="red"
                      matchIndex={index}
                      onChangePlayerScore={onChangePlayerScore}
                    />
                    <MatchPlayer
                      playerIndex={1}
                      match={match}
                      player={match.team1.players?.[1]}
                      team="team1"
                      bgColor="red"
                      matchIndex={index}
                      onChangePlayerScore={onChangePlayerScore}
                    />
                  </MatchWrapper>
                  <SetMatchResult match={match} matchIndex={index} onMatchResultChange={onMatchResultChange} onMatchMarginChange={onMatchMarginChange} />
                  <MatchWrapper data-testid="FRED2">
                    <MatchPlayer
                      playerIndex={0}
                      match={match}
                      player={match.team2.players?.[0]}
                      team="team2"
                      bgColor="blue"
                      matchIndex={index}
                      onChangePlayerScore={onChangePlayerScore}
                    />
                    <MatchPlayer
                      playerIndex={1}
                      match={match}
                      player={match.team2.players?.[1]}
                      team="team2"
                      bgColor="blue"
                      matchIndex={index}
                      onChangePlayerScore={onChangePlayerScore}
                    />
                  </MatchWrapper>
                </DropWrapper>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};
